<template>
  <div id="LanguageList">
    <div class="background-dim" v-if="GET_LANGUAGE_LIST">
      <div class="language-window">
        <div class="title">{{ $t('language') }}</div>
        <div class="language" :class="{ 'selected': language.locale === $i18n.locale }" v-for="(language, idx) in languages" :key="idx" @click="setLanguage(language)">{{ language.text }}</div>
        <button class="btn-hide-window" @click="TOGGLE_LANGUAGE_LIST(false)">{{ $t('close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex';

export default {
  props: [
    'showList'
  ],
  data () {
    return {
      languages: [
        { locale: 'en',  text: 'English' },
        // { locale: 'ko',  text: '한국어' },
        { locale: 'jp',  text: '日本語' },
      ]
    }
  },
  computed: {
    ...vuex.mapGetters({
      'GET_LANGUAGE_LIST': 'request/GET_LANGUAGE_LIST',
      'GET_LANGUAGE': 'request/GET_LANGUAGE'
    })
  },
  created () {
    this.getLanguage();
  },
  methods: {
    ...vuex.mapActions({
      'TOGGLE_LANGUAGE_LIST': 'request/TOGGLE_LANGUAGE_LIST',
      'SET_LANGUAGE': 'request/SET_LANGUAGE'
    }),
    async setLanguage (language) {
      await this.SET_LANGUAGE(language.locale);

      this.$i18n.locale = language.locale; 

      this.TOGGLE_LANGUAGE_LIST(false)
    },
    getLanguage () {
      this.$i18n.locale = this.GET_LANGUAGE || 'en';
    }
  }
}
</script>

<style lang="scss">
#LanguageList {
  .background-dim {
    display: flex;
    justify-content: center;
    align-items: center;

    position: fixed;
    z-index: 1000;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: $black-80;

    .language-window {
      min-width: 300px;
      padding: 30px 30px 20px;

      border-radius: 30px;
      background-color: $white;
      color: $black;
      
      font-family: inherit;
      text-align: center;
      
      .title {
        height: 30px;

        font-size: 20px;
        font-weight: bold;

        line-height: 1.5;
      }

      .language {
        height: 27px;
        margin-top: 16px;

        font-size: 17px;

        line-height: 1.59;
      }

      .selected { 
        color: $color_a;
      }

      .btn-hide-window {
        display: inline-block;
        width: 100%;
        height: 50px;
        margin-top: 28px;

        border: solid 1px $color_a;
        border-radius: 25px;
        font-size: 17px;
        color: $color_a;

        line-height: 50px;

        &:active {
          border-color: $color_a_d;
          color: $color_a_d;
        }
      }
    }
  }
}
</style>